import { render, staticRenderFns } from "./AppConfig.vue?vue&type=template&id=3e54dc41&scoped=true"
import script from "./AppConfig.vue?vue&type=script&lang=js"
export * from "./AppConfig.vue?vue&type=script&lang=js"
import style0 from "./AppConfig.vue?vue&type=style&index=0&id=3e54dc41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54dc41",
  null
  
)

export default component.exports